import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../../shared/services/http-request.service';
import { ApiUrlConstants } from '../../../shared/constants/api_url_constants';
import { Observable, forkJoin } from 'rxjs';
import {  countryShortViewModel, Designation, roleShortViewModel, UserListViewModel, UserViewModel, Users, loggedInUserViewModel, userShortViewModel, accountExeManagerAndCoordinatorViewModel, cityManagerByCityViewModel, userRoleViewModel } from '../../models/user-management/user_models';
import { stateShortViewModel, stateWithCountryViewModel } from '../../models/state-managment/state.model';
import { cityShortViewModel } from '../../models/city-management/city.model';
import { weeklyMeetDocDeptShortViewModel } from 'src/app/all-modules/weekly-meeting/models/weekly_documents.model';
import { ApiResponse, switchRoleReq, switchRoleResponse } from 'src/app/all-modules/shared/common-model/common.model';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private httpRequestService: HttpRequestService) { }

  getAllUsersForList(): Observable<UserListViewModel[]> {
    return this.httpRequestService.getData<UserListViewModel[]>(ApiUrlConstants.userGetAllForList);
  }
  GetAllUserWithShortDetails(): Observable<userShortViewModel[]> {
    return this.httpRequestService.getData<userShortViewModel[]>(ApiUrlConstants.userGetAllWithShortDetails);
  }
  getAllCountryRoleDesgAndWeeklyMeetDept(): Observable<any[]> {
    const getAllCountry$ = this.httpRequestService.getData<countryShortViewModel[]>(ApiUrlConstants.countryGetAll);
    const getAllRole$ = this.httpRequestService.getData<roleShortViewModel>(ApiUrlConstants.getAllRole);
    const getAllDesignation = this.httpRequestService.getData<Designation>(ApiUrlConstants.getAllDesignation);
    const getAllWeeklyDept$ = this.httpRequestService.getData<weeklyMeetDocDeptShortViewModel[]>(ApiUrlConstants.GetAllDept);
    return forkJoin([getAllCountry$, getAllRole$, getAllDesignation, getAllWeeklyDept$]);
  }
  getAllCountryStateCityRoleDesg(): Observable<any[]> {
    const getAllCountry$ = this.httpRequestService.getData<countryShortViewModel[]>(ApiUrlConstants.countryGetAll);
    const getAllState$ = this.httpRequestService.getData<stateShortViewModel[]>(ApiUrlConstants.stateGetAllWithShortDetails);
    const cityGetAll$ = this.httpRequestService.getData<cityShortViewModel[]>(ApiUrlConstants.cityGetAllWithShortDetails);
    const getAllRole$ = this.httpRequestService.getData<roleShortViewModel>(ApiUrlConstants.getAllRole);
    const getAllDesignation = this.httpRequestService.getData<Designation>(ApiUrlConstants.getAllDesignation);
    return forkJoin([getAllCountry$, getAllRole$, getAllDesignation, getAllState$, cityGetAll$]);
  }
  getAllStateRoleDesg(): Observable<any[]> {
    const getAllState$ = this.httpRequestService.getData<stateShortViewModel[]>(ApiUrlConstants.stateGetAllWithShortDetails);
    const getAllRole$ = this.httpRequestService.getData<roleShortViewModel>(ApiUrlConstants.getAllRole);
    const getAllDesignation = this.httpRequestService.getData<Designation>(ApiUrlConstants.getAllDesignation);
    return forkJoin([getAllState$, getAllRole$, getAllDesignation]);
  }
  getAllStateByCountryId(countryId: any): Observable<stateWithCountryViewModel[]> {
    return this.httpRequestService.getData<stateWithCountryViewModel[]>(`${ApiUrlConstants.stateGetAllByCountryId}${countryId}`);
  }

  getUserById(id: any): Observable<UserViewModel> {
    return this.httpRequestService.getData<any>(`${ApiUrlConstants.getUserById}${id}`);
  }
  addUsers(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.addUsers, data);
  }

  updateUser(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.updateUserById, data);
  }

  activeInactiveUser(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.activeInactiveUser, data);
  }
  deleteUser(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.deleteUser, data);
  }
  UserResetPassword(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.UserResetPassword, data);
  }
  ResetPassword(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.ResetPassword, data);
  }
  GetLoggedInUserDetails() {
    return this.httpRequestService.getData<loggedInUserViewModel>(ApiUrlConstants.GetLoggedInUserDetails);
  }

  ChangeProfilePic(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.ChangeProfilePic, data);
  }
  switchRole(userRoleId: switchRoleReq): Observable<switchRoleResponse> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.switchRole, userRoleId);
  }
  getAllActiveAccountExMgrAndCoordinator(): Observable<accountExeManagerAndCoordinatorViewModel[]> {
    return this.httpRequestService.getData<accountExeManagerAndCoordinatorViewModel[]>(ApiUrlConstants.userGetAllActiveAccountExMgrAndCoordinator);
  }
  getAllCityManagersByCityId(cityId:string): Observable<cityManagerByCityViewModel[]> {
    return this.httpRequestService.getData<any>(`${ApiUrlConstants.userGetAllCityManagersByCityId}${cityId}`);
  }
  getAllActiveCityManagers(): Observable<cityManagerByCityViewModel[]> {
    return this.httpRequestService.getData<any>(`${ApiUrlConstants.userGetAllActiveCityManagers}`);
  }
  getActiveAccountManagers(): Observable<userRoleViewModel[]> {
    return this.httpRequestService.getData<userRoleViewModel[]>(ApiUrlConstants.userGetAllActiveAccountManagers);
  }
  estimationUpdateForMigration(): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soScopeEstimationForMigration, null);
  }
   estimationUpdateForMigrationUpateRateCard(): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soScopeEstimationForMigrationRateCard, null);
  }
  getAllActiveEstimator(): Observable<userRoleViewModel[]> {
    return this.httpRequestService.getData<userRoleViewModel[]>(ApiUrlConstants.userGetAllActiveEstimators);
  }
}
